import { render, staticRenderFns } from "./NewSelect.vue?vue&type=template&id=09f8ef7e&"
import script from "./NewSelect.vue?vue&type=script&lang=js&"
export * from "./NewSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports